import { createPlugin } from '@backstage/core-plugin-api';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';

import { AdoProjectPickerComponent } from './components/AdoProjectPickerComponent/AdoProjectPickerComponent';
import { AdoProjectPickerSchema } from './components/AdoProjectPickerComponent/schema';
import { AdoProjectAndRepoPickerComponent } from './components/AdoProjectAndRepoPickerComponent/AdoProjectAndRepoPickerComponent';
import { AdoProjectAndRepoPickerSchema } from './components/AdoProjectAndRepoPickerComponent/schema';

export const scaffolerAdoLoginPlugin = createPlugin({
  id: 'scaffoler-ado-login',
});

export const AdoProjectPicker = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AdoProjectPicker',
    component: AdoProjectPickerComponent,
    schema: AdoProjectPickerSchema
  }),
);
export const AdoProjectAndRepoPicker = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AdoProjectAndRepoPicker',
    component: AdoProjectAndRepoPickerComponent,
    schema: AdoProjectAndRepoPickerSchema
  }),
);
